import React from 'react';
import useApps from '@afosto/utils-react/subscription/useApps';
import useIntl from '@afosto/utils-react/intl/useIntl';
import usePermissions from '@afosto/utils-react/permissions/usePermissions';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import List from '@material-ui/core/List';
import UpcomingInvoiceRow from '../../../../components/UpcomingInvoiceRow';
import translations from './translations';
import CardContent from '@material-ui/core/CardContent';

const UpcomingInvoices = () => {
  const [hasPermissions, UnauthorizedComponent] = usePermissions(['iam:subscriptions:read']);
  const intl = useIntl();
  const apps = useApps();

  if (!hasPermissions()) {
    return (
      <Card>
        <CardHeader
          title={intl.formatMessage(translations.title)}
          titleTypographyProps={{ variant: 'h6' }}
        />
        <CardContent>
          <UnauthorizedComponent showActions={false} />
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader
        title={intl.formatMessage(translations.title)}
        titleTypographyProps={{ variant: 'h6' }}
      />
      <List dense>
        {apps.map((app, index) => (
          <UpcomingInvoiceRow key={app.key} app={app} divider={index + 1 !== apps.length} />
        ))}
      </List>
    </Card>
  );
};

export default UpcomingInvoices;
